import { useEffect, useState } from "react"
import SpotifyPlayer from "react-spotify-web-playback"
import { useGetLyrics } from "../hooks"
import SpotifyWebApi from "spotify-web-api-node"

const spotifyApi = new SpotifyWebApi({
  clientId: "971b948ffd3645aca27b3708306cb672",
})

export const SpotPlayer = ({ accessToken, trackUri, play = true, getCurrentTrack, offset, currentTrack }) => {
  const [hide, setHide] = useState(true)
  const [bars, setBars] = useState(Array(50).fill(0).map(() => 5 + Math.random() * 30))
  const [barPosition, setBarPosition] = useState(0)
  const [playlist, setPlaylist] = useState('')
  const [like, setLike] = useState(false)

  const { lyrics } = useGetLyrics(currentTrack?.artist, currentTrack?.title)

  useEffect(() => {
    if (!accessToken) return
    spotifyApi.setAccessToken(accessToken)
  }, [accessToken])

  useEffect(() => {
    if (like) {
      spotifyApi.getUserPlaylists().then(res =>
      {
        const cosmoxPlaylist = res.body.items.find(el => el.name === 'Cosmox')
        setPlaylist(cosmoxPlaylist?.id ?? '')
        if (!cosmoxPlaylist){
          spotifyApi.createPlaylist("Cosmox", {
            'description': 'Playlist create from Cosmox',
            'collaborative': false,
            'public': false
          }).then(res => {
            setPlaylist(res.body.id)
          })
        }
        spotifyApi.addTracksToPlaylist(playlist,[currentTrack?.uri]).then(res => {})
      })
    } else {
      spotifyApi.removeTracksFromPlaylist(playlist,[currentTrack]).then(res => {})
    }
    
  }, [like, accessToken]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    //récupérer la position depuis le player de spotify pour l'ajouter au slider
    const slider = document.getElementsByClassName('_SliderRSWP __1lztbt5')[0]
    setBarPosition(slider?.dataset.position / 2)
    // `setInterval` pour exécuter une fonction qui diminue le temps restant de 1 chaque seconde
    const interval = setInterval(() => {
      bars.shift()
      setBars([...bars,(5 + Math.random() * 30)])
    }, 250)
    // `clearInterval` pour nettoyer l'intervalle
    return () => clearInterval(interval)
  }, [bars]) // eslint-disable-line react-hooks/exhaustive-deps 

  const fullScreen = (e) => {
    e.stopPropagation()
    setHide(false)
  }

  if (!accessToken) return null

  return (
  <>
    <div className="pl">
      <SpotifyPlayer
        token={accessToken}
        showSaveIcon={false}
        hideAttribution
        hideCoverArt
        magnifySliderOnHover
        inlineVolume 
        layout="compact"
        callback={state => {
          getCurrentTrack(state.nextTracks[0]?.uri)
        }} 
        offset={offset ?? trackUri.length / 2}
        play={play}
        uris={trackUri ?? []}
        styles={{
          bgColor: '#7a57e453',
          color: '#fff',
          loaderColor: '#fff',
          sliderColor: '#7a57e4',
          trackArtistColor: '#fff',
          trackNameColor: '#fff',
        }}
      />
      {currentTrack &&
        <svg className='icon open' onClick={fullScreen}>
          <use xlinkHref='#icon-full-screen'/>
        </svg>
      }
    </div>

    {!hide && 
      <div className="player">
        <svg className='icon close' onClick={() => setHide(true)}>
          <use xlinkHref='#icon-arrow-down'/>
        </svg>
        <div className="now-playing full">
          <img src={currentTrack?.albumUrl} className="now-playing__cover" alt="" />
          <div className='now-playing__title'>
            <div>
              <h3 className="artist"><strong>{ currentTrack.artist }</strong></h3>
              <span className="name">{currentTrack.title}</span>
            </div>
            <button onClick={() => setLike(!like)} >
              <svg className={`icon ${like ? 'like' : ''}`}>
                <use xlinkHref='#icon-heart'/>
              </svg>
            </button>
          </div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 500 100"
            width="100%"
            height="100%"
          >
            <g transform="translate(10,50)">
              {bars.map((yabs,index) => 
                <line 
                  key={index}
                  x1={index*10}
                  y1={-yabs}
                  x2={index*10}
                  y2={yabs}
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeWidth="6"
                  className={[index >= 0 && index < barPosition ? 'eq-filled' : 'eq-empty']}
                />
              )}

            </g>
          </svg>
          <div className="lyrics">
            <p>{lyrics}</p>
          </div>
        </div>
      </div>
      }
  </>
    
  )
}
